<template>
  <div>
    <!-- 搜索区 -->
    <DirectRecordSearch
      :searchOptions="searchOptions"
      :searchData="searchParams"
      @onSearch="getList"
      @clearAll="onSearch"
    />
    <el-button v-if="$hasAuthority('tvoperate_add')" type="primary" class="mb20" @click="newCreate">新建</el-button>

    <c-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="searchParams"
        :tabIndexPageReset="true"
        :pager="true"
        :api="getClassInfoList"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <!-- 自定义列表内容 -->
        <template v-slot:col-state="scope">
          <p>{{ scope.row.status === 1 ? '已发布' : '未发布' }}</p>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-state="scope">
          <el-button
            v-if="$hasAuthority('tvoperate_publish')"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.status === 1 ? '取消发布' : '发布' }}
          </el-button>
          <el-button v-if="$hasAuthority('tvoperate_alter')" type="text" @click="edit(scope.data.row)">编辑</el-button>
          <el-button v-if="$hasAuthority('tvoperate_scheduleAdmin')" type="text" @click="richengManage(scope.data.row)">日程管理</el-button>
          <el-button v-if="$hasAuthority('tvoperate_installCredential')" type="text" @click="configEnd(scope.data.row)">配置结业证</el-button>
          <el-button v-if="$hasAuthority('tvoperate_installConformity')" type="text" @click="configCertificate(scope.data.row)">配置合格证</el-button>
          <el-button v-if="$hasAuthority('tvoperate_classInfo')" type="text" @click="classDetail(scope.data.row)">班级详情</el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-delete="scope">
          <el-button
            v-if="scope.data.row.status === 1"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
      </c-table>

    <HandleCourse ref='dialogCourse' :editParams='editParams' @success='success'></HandleCourse>
    <HandleDateManage ref='dialogDate' :editParams='editParams'></HandleDateManage>
    <HandleCerCompletion ref="dialogCerCompletion" :editParams='editParams' @success='success'></HandleCerCompletion>
    <HandleCerQualified ref="dialogCerQualified" :editParams='editParams' @success='success'></HandleCerQualified>
    <HandleClassDetail v-if="showDetailDialog" ref="dialogClassDetail" :editParams='editParams'></HandleClassDetail>

  </div>
</template>

<script>
import CTable from '@/components/PublicTableCopy';
import DirectRecordSearch from "@/components/Search/index";
import HandleCourse from "./handle.vue";
import HandleDateManage from "./handle-date-list.vue";
import HandleCerCompletion from "./handle-cer-completion.vue";
import HandleCerQualified from "./handle-cer-qualified.vue";
import HandleClassDetail from "./handle-class-detail.vue";
import { getClassInfoList,setClassInfoStatus } from '@/api/api'

export default {
  components: {
    CTable,
    DirectRecordSearch,
    HandleCourse,
    HandleDateManage,
    HandleCerCompletion,
    HandleCerQualified,
    HandleClassDetail
  },
  data() {
    return {
      getClassInfoList,
      setClassInfoStatus,
      editParams:{},
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        fieldList: [
          // { label: '排序号', value: 'id' },
          { label: '班级名称', value: 'name'},
          { label: '学时', value: 'period'},
          { label: '开班时间', value: 'openStartTime'},
          { label: '闭班时间', value: 'openEndTime'},
          { label: '创建时间', value: 'insertDate'},
          { label: '状态', value: 'state', type: 'slot' },
        ],
        handle: {
          label: '操作',
          btList: [
            { label: '启用', type: 'text', event: 'state', show: true, slot: true },
            // { label: '删除', type: 'text', event: 'delete', show: true, slot: true },
            // { label: '编辑', type: 'text', event: 'edit', show: true },
          ]
        }
      },
      // 搜索表单配置项
      searchOptions: [
        {
          type: "input",
          label: "班级名称",
          prop: "name",
          width: "230px",
          placeholder: "请输入班级名称",
          // querySearchAsync: querySearchAsync,
        },

        {
          type: "select",
          label: "状态",
          prop: "status",
          width: "230px",
          placeholder: "请输入状态",
          data:[{
            label:'发布',
            value:'1'
          },{
            label:'未发布',
            value:'2'
          }]
          // querySearchAsync: querySearchAsync,
        },
        // {
        //   type: "input",
        //   label: "行号：",
        //   prop: "bankNo",
        //   width: "230px",
        //   placeholder: "请输入行号",
        // },
      ],
      searchParams: {
      },
      showDetailDialog: false
    };
  },
  mounted(){
    this.getList();
  },
  methods: {
     // 通过随机数请求列表
    getList(params) {
      this.searchParams = params
      this.tableInfo.refresh = Math.random();
    },
    success(){
      this.editParams={};
      this.getList(this.searchParams)
    },
    create(){
      this.$refs.dialog.setOpacity(true)
    },
    newCreate(){
      this.editParams = { period: 40, issuingAuthority: '国家广播电视总局广播影视人才交流中心' }
      this.showDialog('dialogCourse')
    },
    edit(row){
      this.showDialog('dialogCourse')
      this.editParams = JSON.parse(JSON.stringify(row));
    },
    showDialog(componentName){
      this.$refs[componentName].setOpacity(true)
    },
    classDetail(row){
      this.editParams = JSON.parse(JSON.stringify(row));
      this.showDetailDialog = false
      setTimeout(() => {
        this.showDetailDialog = true
        this.$nextTick(() => {
          this.showDialog('dialogClassDetail')
        })
      }, 30);
    },
    configCertificate(row){
      this.editParams = JSON.parse(JSON.stringify(row));
      this.showDialog('dialogCerQualified')
    },
    configEnd(row){
      this.editParams = JSON.parse(JSON.stringify(row));
      this.showDialog('dialogCerCompletion')
    },
    richengManage(row){
      this.editParams = JSON.parse(JSON.stringify(row));
      this.showDialog('dialogDate');
    },
    // 查询
    onSearch(data) {
        console.log(data)
    },
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
    handleClick(event,row){
      console.log(row)
      if (event === 'edit') {
        this.create();
        this.editParams = row;
        // this.$refs.cooperatorDialog.init(row);
        // this.dialogVisible = true;
      } else if (event === 'state') {
        setClassInfoStatus({
          id: row.id,
          status:row.status === 1 ? 2 : 1
        }).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success(row.state === 1 ? '发布成功' : '取消发布成功');
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      } else {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteTrain({
            id: row.id
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        });
      }
    },
    // 切换选择
    changeTableSelection(val) {
      console.log(val);
    },
    // 操作
    showDetail(row) {
      console.log(row);
    },
    getAcceptBankLevelType(){

    }
  },
};
</script>
<style lang='scss' scoped>
.mb20{
  margin-bottom: 20px;
}
</style>
